// i switched the names order to make spacing look more even
function Team(){
    return (
      <div
        className="font-apfelgrotezk mt-[60px] ml-[12px] mb-[67px]
                    desktop:mt-[117px] desktop:ml-[28px] tablet:ml-[20px]"
      >
        <h2 className="text-blackboxmob text-[#FF00D6] bg-[#311500] w-[37px] pl-[3px] desktop:w-[112px] desktop:text-blackbox desktop:pl-[10px] tablet:w-[60px] tablet:text-blackboxt tablet:pl-[6px]">
          TEAM
        </h2>
        <section
          className="text-[12px] mt-[10px] grid grid-cols-3 min-w-[320px] gap-x-[24px] gap-y-[10px] mb-[100px]
                            desktop:text-[21px] desktop:mt-[26px] desktop:grid-cols-4 desktop:w-[750px] desktop:gap-x-[38px] desktop:gap-y-[52px] desktop:mb-[170px]
                            tablet:text-blackboxt tablet:mt-[20px] tablet:gap-y-[30px] desktop:text-nav"
        >
          <div className="">
            <p>Russell Taylor</p>
            <p>DIRECTOR</p>
          </div>
          <div className="o">
            <p>Claret Egwim</p>
            <p>COORDINATOR</p>
          </div>
          <div className="">
            <p>Nathan Lew</p>
            <p>DESIGNER</p>
          </div>
          <div className="">
            <p>Francesca Reyes</p>
            <p>DESIGNER</p>
          </div>
          <div>
            <p>Jessica Li</p>
            <p>WEB DEVELOPER</p>
          </div>
          <div className="">
            <p>Karishma Sen</p>
            <p>VOLUNTEER OPS</p>
          </div>
          <div className="">
            <p>Dennis Limbo</p>
            <p>TECHNICIAN</p>
          </div>
          <div className="">
            <p>Jonathan Choi</p>
            <p>TECHNICIAN</p>
          </div>
        </section>
      </div>
    );
}

export default Team;